
/* System defined core library */
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined models */
import { TestingAccommodation } from '../../../../shared/models/scheduling/testingaccommodation.model';
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';


@Component({
    selector: 'app-testing-accommodation',
    templateUrl: './testing-accommodation.component.html',
    styleUrls: ['./testing-accommodation.component.scss']
})

export class TestingAccommodationComponent implements OnInit {



    /* Service subscriptions */
    translateLanguage$: Subscription;

    @Input() testingAccommodationObj: TestingAccommodation[];
    public testingAccommodation: TestingAccommodation[] = [];

    constructor(
        private translate: TranslateService,
        private selectedExamDetailService: SelectedExamDetailService

    ) {
        translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
        this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
            languageCode => {
                translate.use(languageCode);
            }
        );

    }

    ngOnInit(): void {
        this.testingAccommodation = this.testingAccommodationObj;
    }

    shouldTranslate(ta: any) {
        if (ta && ta.displayId) {
            return (ta.displayId.toString().toLowerCase() === 'centerwithwheelchairaccess' ||
                ta.displayId.toString().toLowerCase() === 'examvoiceoverlanguage' ||
                ta.displayId.toString().toLowerCase() === 'signlanguagevideo');
        }
        return false;
    }

}
